import { Pagination, IconButton, Flex, UsePaginationProps } from '@chakra-ui/react'
import { LuChevronDown, LuChevronUp } from 'react-icons/lu'

export const PaginationComponent = (props: UsePaginationProps) => {
    return (
        <Pagination.Root
            count={props.count}
            pageSize={props.pageSize}
            page={props.page}
            onPageChange={props.onPageChange}
        >
            <Flex align={'center'} gap={2}>
                <Pagination.PageText format={'short'} textWrap={'nowrap'} />
                <Flex direction={'column'}>
                    <Pagination.PrevTrigger asChild>
                        <IconButton variant={'ghost'} size="sm">
                            <LuChevronUp />
                        </IconButton>
                    </Pagination.PrevTrigger>
                    <Pagination.NextTrigger asChild>
                        <IconButton variant={'ghost'} size="sm">
                            <LuChevronDown />
                        </IconButton>
                    </Pagination.NextTrigger>
                </Flex>
            </Flex>
        </Pagination.Root>
    )
}
